// extracted by mini-css-extract-plugin
module.exports = {"HomeProject":"HomeProject_HomeProject__364A0","textContent":"HomeProject_textContent__11iVc"};